let notificationApi = null;
const pendingOperations = [];

const runOrQueue = (operation) => {
  if (notificationApi) {
    operation(notificationApi);
    return;
  }

  pendingOperations.push(operation);
};

export const setNotificationApi = (api) => {
  notificationApi = api;

  if (!notificationApi || pendingOperations.length === 0) {
    return;
  }

  pendingOperations.splice(0).forEach((operation) => operation(notificationApi));
};

export const openNotification = (type, config) => {
  runOrQueue((api) => api[type](config));
};

export const closeNotification = (key) => {
  runOrQueue((api) => api.destroy(key));
};
